<div class="oy_search_input_guessBox"><span class="{{styles.oy_search_input_guessLabel}}">猜你想找</span> <span>{{ each props.data val ind }} <a class="{{styles.oy_search_input_guessName}}" href="/search-ng/queryResourceZPPC/_search?keySearch={{val.remark}}" target="_blank">{{ val.remark }}</a> {{/each}}  </span></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYSearch/templates/autoGuessComplete.art